import { render, staticRenderFns } from "./planGoodsorder.vue?vue&type=template&id=542bb8fd&scoped=true&"
import script from "./planGoodsorder.vue?vue&type=script&lang=js&"
export * from "./planGoodsorder.vue?vue&type=script&lang=js&"
import style0 from "./planGoodsorder.vue?vue&type=style&index=0&id=542bb8fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542bb8fd",
  null
  
)

export default component.exports